export default "__VITE_ASSET__gcZAHa9S__"